import { transformMetaField } from '@/utils/shopify';

export const productMetaFieldTransformer = (productData) => {
  const metafieldKeys = [
    'accordion',
    'badges',
    'bundleProduct',
    'cardHeader',
    'exercises',
    'flags',
    'keyFeatures',
    'optionSwatches',
    'productCardUsp',
    'relatedProducts',
    'testimonial',
    'video',
    'comparison',
    'digitalAddOn',
    'digitalProductType',
    'subtitle',
    'imageMetadata',
  ];

  if (!productData) {
    console.warn('productMetaFieldTransformer: productData is null or undefined');
    return null;
  }

  metafieldKeys.forEach((field) => transformMetaField(productData, field));

  // set made in germany flag for product data
  productData.isMadeInGermany = productData?.flags?.madeInGermany ?? false;

  return productData;
};
